import { useState } from "react";
import Textarea from "../../../componentes/input/textarea";
import Button from "../../../componentes/button/button";

// Comentários registrados ANTES de existir uma solicitação (ficam em memória até o cadastro ser enviado).
export default function ComentariosStagedEditor({ itens = [], onChange }) {
    const [texto, setTexto] = useState("");

    function adicionar() {
        if (!texto.trim()) return;
        onChange([...itens, { texto: texto.trim() }]);
        setTexto("");
    }

    function remover(index) {
        onChange(itens.filter((_, i) => i !== index));
    }

    return (
        <div className="flex flex-col gap-2">
            {itens.length > 0 && (
                <div className="flex flex-col gap-2 max-h-60 overflow-y-auto pr-1">
                    {itens.map((item, index) => (
                        <div key={index} className="flex items-start gap-2 bg-muted rounded-lg rounded-tl-none p-3">
                            <p className="flex-1 text-sm text-foreground break-words">{item.texto}</p>
                            <button
                                type="button"
                                onClick={() => remover(index)}
                                className="shrink-0 text-destructive hover:bg-destructive/10 rounded-full p-1"
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>
                    ))}
                </div>
            )}

            <Textarea
                id="comentario-inicial"
                placeholder="Escreva um comentário..."
                value={texto}
                onChange={e => setTexto(e.target.value)}
                rows={2}
            />
            <div className="flex justify-end">
                <Button
                    variant="outline"
                    label="Adicionar comentário"
                    iconLeft="fa fa-plus"
                    disabled={!texto.trim()}
                    onClick={adicionar}
                />
            </div>
        </div>
    );
}
